export enum SubscriptionPrices {
	GEEK = 12.9,
	BRANCHE = 9.9
}
